const CDN = 'https://images.sitco.ru';

export interface ProjectData {
  slug: string;
  title: string;

  category: string;
  listCategoryDescription: string;

  listLogo: string;
  listDescription: string;

  titleBg: string;

  aboutText: string[];

  client: string;
  site: string;
  year: string;

  roles: string[];

  credits: {
    role: string;
    name: string;
  }[];

  galleryImages: string[];
  aboutBg: string;

  nextSlug: string;
}

export const PROJECTS: ProjectData[] = [
  {
    slug: 'fcs',

    title: 'First Class Solutions Ltd',

    category: 'Travel Tech',
    listCategoryDescription: 'Travel platforms and booking systems for the tourism industry',

    listLogo: `${CDN}/main/f-logo-s.svg`,
    listDescription: 'Luxury travel, private aviation, yachts and airport services',

    titleBg: `${CDN}/projects/fcs/title-bg.png`,

    aboutText: [
      'First Class Solutions Ltd is a luxury travel and concierge service platform focused on private aviation, yachts, premium airport services, and bespoke travel experiences. The project brings together a refined visual style, clear service presentation, and a smooth digital journey for high-end clients.',

      'The website was designed to communicate trust, exclusivity, and operational precision. The interface combines editorial layouts, atmospheric imagery, responsive structure, and straightforward navigation to help users explore services and quickly reach the company.',
    ],

    client: 'First Class Solutions Ltd',
    site: 'ilovefirstclass.com',
    year: '2026',

    roles: ['Web Development', 'Frontend Architecture', 'Responsive Design', 'Interaction Design'],

    credits: [
      {
        role: 'Art Direction',
        name: 'Name Surname',
      },
      {
        role: 'Web Development',
        name: 'Name Surname',
      },
      {
        role: 'Brand Design',
        name: 'Name Surname',
      },
      {
        role: 'Photography',
        name: 'Name Surname',
      },
    ],

    galleryImages: [
      `${CDN}/projects/fcs/1.png`,
      `${CDN}/projects/fcs/2.png`,
      `${CDN}/projects/fcs/3.png`,
      `${CDN}/projects/fcs/4.png`,
      `${CDN}/projects/fcs/5.png`,
    ],

    aboutBg: `${CDN}/projects/fcs/about-bg.png`,

    nextSlug: 'meet-greet',
  },

  {
    slug: 'meet-greet',

    title: 'Meet + Greet',

    category: 'Travel Tech',
    listCategoryDescription: 'Travel platforms and booking systems for the tourism industry',

    listLogo: `${CDN}/main/m-logo-s.svg`,
    listDescription: 'Premium airport booking platform',

    titleBg: `${CDN}/projects/meet-greet/title-bg.png`,

    aboutText: [
      'Meet + Greet is a premium airport booking platform created for travelers who need a seamless and comfortable experience before, during, and after their flight. The product focuses on airport assistance, lounge access, fast-track services, transfers, and passenger-focused booking scenarios.',

      'The interface was built around a flexible booking flow, clear service selection, responsive layouts, and detailed order summaries. Special attention was given to usability, visual consistency, and performance across desktop and mobile devices.',
    ],

    client: 'Meet + Greet',
    site: 'meetandgreet.aero',
    year: '2026',

    roles: [
      'Web Development',
      'Frontend Architecture',
      'UX/UI Implementation',
      'Responsive Development',
    ],

    credits: [
      {
        role: 'Art Direction',
        name: 'Name Surname',
      },
      {
        role: 'Web Development',
        name: 'Name Surname',
      },
      {
        role: 'Brand Design',
        name: 'Name Surname',
      },
      {
        role: 'Photography',
        name: 'Name Surname',
      },
    ],

    aboutBg: `${CDN}/projects/meet-greet/about-bg.png`,

    galleryImages: [`${CDN}/projects/meet-greet/1.png`, `${CDN}/projects/meet-greet/2.png`],

    nextSlug: 'shatte',
  },

  {
    slug: 'shatte',

    title: 'Shatte',

    category: 'E-commerce',
    listCategoryDescription: 'B2B & B2C digital solutions',

    listLogo: `${CDN}/main/s-logo-s.svg`,
    listDescription: 'Womens fashion and clothing design brand',

    titleBg: `${CDN}/projects/shatte/title-bg.png`,

    aboutText: [
      'Shatte is an e-commerce project for a womens fashion and clothing design brand. The platform focuses on a clean product experience, elegant visual presentation, and a simple path from discovery to purchase.',

      'The digital storefront was designed with responsive product layouts, refined typography, smooth interaction states, and scalable frontend components. The result is a minimal and flexible shopping experience that supports both brand storytelling and commercial goals.',
    ],

    client: 'Shatte',
    site: 'shatte.store',
    year: '2026',

    roles: ['Frontend Development', 'UI Animation', 'Responsive Design', 'Interaction Design'],

    credits: [
      {
        role: 'Creative Direction',
        name: 'Name Surname',
      },
      {
        role: 'Frontend Development',
        name: 'Name Surname',
      },
      {
        role: 'Visual Identity',
        name: 'Name Surname',
      },
      {
        role: 'Photography',
        name: 'Name Surname',
      },
    ],

    aboutBg: `${CDN}/projects/shatte/about-bg.png`,

    galleryImages: [
      `${CDN}/projects/shatte/1.png`,
      `${CDN}/projects/shatte/2.png`,
      `${CDN}/projects/shatte/3.png`,
    ],

    nextSlug: 'fcs',
  },
];
